import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ProfileSettingsRoutingService {
  passwordprocess = false;
  private routeSubject: BehaviorSubject<any>;
  private changePasswordAlert = new BehaviorSubject<boolean>(false);
  private passwordprocesssource = new BehaviorSubject<boolean>(
    this.passwordprocess
  );
  $passwordprocess = this.passwordprocesssource.asObservable();
  $alert = this.changePasswordAlert.asObservable();
  $routeSubject;
  oldPassword: string;

  constructor(private router: ActivatedRoute) {
   this.routeSubject = new BehaviorSubject<any>(this.router.pathFromRoot);
   this.$routeSubject = this.routeSubject.asObservable();
  }

  setChangePasswordAlert(value: boolean) {
    this.changePasswordAlert.next(value);
  }

  setRouteSubject(route: any) {
    this.routeSubject.next(route);
  }

  setDefault() {
    this.changePasswordAlert.next(false);
  }

  setPasswordProcess(value) {
    this.passwordprocesssource.next(value);
  }

  clearPasswordProcess() {
    this.passwordprocesssource.next(false);
  }

  setOldPassword(oldPass: string) {
    this.oldPassword = oldPass;
  }

  getOldPassword() {
    return this.oldPassword;
  }

  clearOldPassword() {
    this.oldPassword = '';
  }
}
